<template>
  <div v-if="showCounter" class="menu-item-counter">
    {{ count }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MenuItemCounter",
  props: {
    menuItem: Object
  },
  computed: {
    ...mapGetters({
      showImages: "venueSettings/showMenuItemsImages",
      getCountInCart: "cart/getItemsCountInCart"
    }),
    count() {
      return this.getCountInCart(this.menuItem);
    },
    showCounter() {
      return this.showImages && this.count > 0;
    }
  }
};
</script>

<style scoped lang="scss">
.menu-item-counter {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 8px;
  line-height: 20px;
  border-radius: 0px 5px;
  text-align: center;
  background-color: $group-4-color-1;
  color: white;
  font-size: 11px;
  box-sizing: border-box;
}

@include respond-to-mobile-xs {
  .menu-item-counter {
    width: 25px;
    height: 25px;
    line-height: 20px;
    font-size: 11px;
  }
}
</style>
